// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Book a Demo — conversational booking page (brand: Midnight #071D31, Steel #3B6B94, Turquoise #6CE5E8) */

.bd-page {
  min-height: 100vh;
  background: radial-gradient(1200px 700px at 80% -10%, #10375c 0%, #071d31 55%, #050f1c 100%);
  font-family: 'Greycliff CF', 'Segoe UI', sans-serif;
  color: #fff;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.bd-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.35;
  pointer-events: none;
  animation: bd-float 12s ease-in-out infinite alternate;
}
.bd-glow-a { width: 420px; height: 420px; background: #6ce5e8; top: -140px; left: -120px; }
.bd-glow-b { width: 520px; height: 520px; background: #3b6b94; bottom: -200px; right: -160px; animation-delay: -6s; }
@keyframes bd-float { from { transform: translateY(0) } to { transform: translateY(50px) } }

.bd-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 40px;
  position: relative;
  z-index: 2;
}
.bd-logo { height: 40px; }
.bd-back { color: #9fc3d9; text-decoration: none; font-size: 14px; }
.bd-back:hover { color: #6ce5e8; }

.bd-layout {
  flex: 1 1;
  display: grid;
  grid-template-columns: 1fr 480px;
  gap: 48px;
  max-width: 1160px;
  width: 100%;
  margin: 0 auto;
  padding: 20px 40px 48px;
  align-items: center;
  position: relative;
  z-index: 2;
}

.bd-pitch h1 { font-size: 46px; font-weight: 800; line-height: 1.15; margin-bottom: 18px; }
.bd-pitch h1 span { color: #6ce5e8; }
.bd-pitch p { color: #b8cddd; font-size: 17px; line-height: 1.65; max-width: 420px; }
.bd-pitch ul { list-style: none; padding: 0; margin-top: 26px; }
.bd-pitch li { color: #d7e6f0; margin-bottom: 12px; font-size: 15px; }

/* ── Chat card ─────────────────────────────── */
.bd-chat {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(108, 229, 232, 0.18);
  backdrop-filter: blur(18px);
  border-radius: 22px;
  display: flex;
  flex-direction: column;
  height: min(680px, calc(100vh - 140px));
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45);
  overflow: hidden;
}

.bd-chat-top {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(7, 29, 49, 0.5);
}
.bd-agent-name { font-weight: 700; font-size: 15px; }
.bd-agent-role { font-size: 12px; color: #8fb4cc; }

.bd-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b6b94, #6ce5e8);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  color: #071d31;
  position: relative;
  flex-shrink: 0;
}
.bd-avatar-sm { width: 28px; height: 28px; font-size: 12px; align-self: flex-end; }
.bd-online {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 10px;
  height: 10px;
  background: #2fdd7f;
  border-radius: 50%;
  border: 2px solid #0b2740;
}

.bd-stream {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  scroll-behavior: smooth;
  position: relative;
}

.bd-row { display: flex; gap: 8px; animation: bd-pop 0.28s ease both; }
.bd-row-user { justify-content: flex-end; }
@keyframes bd-pop {
  from { opacity: 0; transform: translateY(10px) scale(0.97); }
  to { opacity: 1; transform: none; }
}

.bd-bubble-wrap { max-width: 82%; }
.bd-bubble {
  padding: 11px 15px;
  border-radius: 16px;
  font-size: 14.5px;
  line-height: 1.5;
  width: fit-content;
}
.bd-bubble-agent {
  background: rgba(255, 255, 255, 0.1);
  border-bottom-left-radius: 4px;
  color: #eaf4fa;
}
.bd-bubble-user {
  background: linear-gradient(135deg, #6ce5e8, #3fd3d7);
  color: #071d31;
  font-weight: 600;
  border-bottom-right-radius: 4px;
  margin-left: auto;
}
.bd-celebrate { border: 1px solid rgba(108, 229, 232, 0.5); box-shadow: 0 0 24px rgba(108, 229, 232, 0.25); }

/* typing dots */
.bd-typing { display: flex; gap: 5px; padding: 14px 16px; }
.bd-typing span {
  width: 7px; height: 7px; border-radius: 50%;
  background: #8fb4cc;
  animation: bd-blink 1.1s infinite;
}
.bd-typing span:nth-child(2) { animation-delay: 0.18s; }
.bd-typing span:nth-child(3) { animation-delay: 0.36s; }
@keyframes bd-blink { 0%, 60%, 100% { opacity: 0.3; transform: translateY(0); } 30% { opacity: 1; transform: translateY(-3px); } }

/* chips / days / slots */
.bd-chips, .bd-slots { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }
.bd-chip, .bd-slot {
  background: transparent;
  border: 1px solid rgba(108, 229, 232, 0.55);
  color: #6ce5e8;
  border-radius: 999px;
  padding: 8px 16px;
  font-size: 13.5px;
  cursor: pointer;
  transition: all 0.18s;
  font-family: inherit;
}
.bd-chip:hover, .bd-slot:hover, .bd-day:hover {
  background: #6ce5e8;
  color: #071d31;
  transform: translateY(-1px);
}

.bd-days { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-top: 10px; }
.bd-day {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(108, 229, 232, 0.35);
  color: #eaf4fa;
  border-radius: 12px;
  padding: 9px 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  transition: all 0.18s;
  font-family: inherit;
}
.bd-day span { font-size: 11px; color: #8fb4cc; text-transform: uppercase; }
.bd-day b { font-size: 13px; }
.bd-day:hover span, .bd-day:hover b { color: #071d31; }

/* confirm card */
.bd-card {
  margin-top: 10px;
  background: rgba(7, 29, 49, 0.65);
  border: 1px solid rgba(108, 229, 232, 0.35);
  border-radius: 16px;
  padding: 16px 18px;
}
.bd-card-when { font-weight: 800; font-size: 15.5px; color: #6ce5e8; margin-bottom: 8px; }
.bd-card-tz { font-weight: 400; font-size: 12px; color: #8fb4cc; }
.bd-card-line { font-size: 13.5px; color: #cfe2ee; margin-bottom: 3px; }
.bd-card-focus { color: #8fb4cc; font-style: italic; }
.bd-card-actions { display: flex; gap: 10px; margin-top: 14px; }
.bd-confirm {
  background: linear-gradient(135deg, #6ce5e8, #3fd3d7);
  color: #071d31;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.15s;
}
.bd-confirm:hover { transform: scale(1.04); }
.bd-teams-link {
  display: inline-block;
  margin-top: 10px;
  background: linear-gradient(135deg, #6ce5e8, #3fd3d7);
  color: #071d31;
  font-weight: 700;
  font-size: 13.5px;
  text-decoration: none;
  border-radius: 10px;
  padding: 10px 18px;
  transition: transform 0.15s;
}
.bd-teams-link:hover { transform: scale(1.04); color: #071d31; }
.bd-edit {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #cfe2ee;
  border-radius: 10px;
  padding: 10px 16px;
  cursor: pointer;
  font-family: inherit;
}

/* input bar */
.bd-inputbar { padding: 14px 16px 18px; border-top: 1px solid rgba(255, 255, 255, 0.08); }
.bd-inputbar-off { opacity: 0.45; }
.bd-error { color: #ffb1b1; font-size: 12.5px; margin-bottom: 6px; }
.bd-inputrow { display: flex; gap: 10px; }
.bd-inputrow input {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(108, 229, 232, 0.25);
  border-radius: 999px;
  padding: 12px 18px;
  color: #fff;
  font-size: 14px;
  outline: none;
  font-family: inherit;
}
.bd-inputrow input:focus { border-color: #6ce5e8; }
.bd-inputrow input::placeholder { color: #7d9cb3; }
.bd-inputrow button {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #6ce5e8, #3b6b94);
  color: #071d31;
  font-size: 17px;
  cursor: pointer;
  transition: transform 0.15s;
}
.bd-inputrow button:not(:disabled):hover { transform: scale(1.08); }
.bd-inputrow button:disabled { cursor: default; opacity: 0.6; }

/* confetti */
.bd-confetti { position: sticky; bottom: 0; height: 0; }
.bd-confetti i {
  position: absolute;
  bottom: 0;
  left: calc(4% * var(--i));
  width: 8px;
  height: 13px;
  background: #6ce5e8;
  opacity: 0;
  animation: bd-confetti 1.6s ease-out forwards;
  animation-delay: calc(0.05s * var(--i));
}
.bd-confetti i:nth-child(3n) { background: #3b6b94; border-radius: 50%; }
.bd-confetti i:nth-child(4n) { background: #ffffff; width: 6px; height: 6px; }
@keyframes bd-confetti {
  0% { opacity: 1; transform: translateY(0) rotate(0); }
  100% { opacity: 0; transform: translateY(-340px) rotate(540deg) translateX(30px); }
}

/* responsive */
@media (max-width: 991px) {
  .bd-layout { grid-template-columns: 1fr; gap: 24px; padding: 10px 20px 30px; align-items: start; }
  .bd-pitch h1 { font-size: 32px; }
  .bd-pitch p { font-size: 15px; }
  .bd-pitch ul { display: none; }
  .bd-header { padding: 18px 20px; }
  .bd-chat { height: min(620px, calc(100vh - 220px)); }
  .bd-days { grid-template-columns: repeat(4, 1fr); }
}

/* phones: the chat IS the page — compact pitch, chat fills the visible viewport */
@media (max-width: 575px) {
  .bd-page { min-height: 100dvh; }
  .bd-header { padding: 12px 16px; }
  .bd-logo { height: 30px; }
  .bd-layout { gap: 12px; padding: 0 12px 16px; }
  .bd-pitch h1 { font-size: 22px; margin-bottom: 0; }
  .bd-pitch p { display: none; }
  .bd-chat {
    height: calc(100vh - 150px);
    height: calc(100dvh - 150px);
    border-radius: 18px;
  }
  .bd-stream { padding: 14px 12px; }
  .bd-bubble-wrap { max-width: 90%; }
  .bd-bubble { font-size: 14px; }
  .bd-days { grid-template-columns: repeat(4, 1fr); gap: 6px; }
  .bd-chip, .bd-slot { padding: 8px 13px; font-size: 13px; }
  .bd-card-actions { flex-wrap: wrap; }
  .bd-inputbar { padding: 10px 10px 12px; }
  /* 16px stops iOS Safari from zooming the page when the input gets focus */
  .bd-inputrow input { font-size: 16px; padding: 11px 16px; }
  .bd-inputrow button { width: 44px; height: 44px; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/bookdemo.css"],"names":[],"mappings":"AAAA,0GAA0G;;AAE1G;EACE,iBAAiB;EACjB,4FAA4F;EAC5F,mDAAmD;EACnD,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,sDAAsD;AACxD;AACA,aAAa,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE;AAC1F,aAAa,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE,oBAAoB,EAAE;AACpH,sBAAsB,OAAO,yBAAyB,EAAE,KAAK,4BAA4B,EAAE;;AAE3F;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA,WAAW,YAAY,EAAE;AACzB,WAAW,cAAc,EAAE,qBAAqB,EAAE,eAAe,EAAE;AACnE,iBAAiB,cAAc,EAAE;;AAEjC;EACE,SAAO;EACP,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,eAAe,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AAC1F,oBAAoB,cAAc,EAAE;AACpC,cAAc,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACpF,eAAe,gBAAgB,EAAE,UAAU,EAAE,gBAAgB,EAAE;AAC/D,eAAe,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAErE,iDAAiD;AACjD;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;EAClD,gCAAgC;AAClC;AACA,iBAAiB,gBAAgB,EAAE,eAAe,EAAE;AACpD,iBAAiB,eAAe,EAAE,cAAc,EAAE;;AAElD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;AACA,gBAAgB,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,oBAAoB,EAAE;AAClF;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,UAAU,aAAa,EAAE,QAAQ,EAAE,iCAAiC,EAAE;AACtE,eAAe,yBAAyB,EAAE;AAC1C;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA,kBAAkB,cAAc,EAAE;AAClC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;AACA,gBAAgB,0CAA0C,EAAE,8CAA8C,EAAE;;AAE5G,gBAAgB;AAChB,aAAa,aAAa,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAC1D;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB;EAC3C,mBAAmB;EACnB,iCAAiC;AACnC;AACA,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,sBAAsB,gBAAgB,YAAY,EAAE,wBAAwB,EAAE,EAAE,MAAM,UAAU,EAAE,2BAA2B,EAAE,EAAE;;AAEjI,yBAAyB;AACzB,uBAAuB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACnF;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,WAAW,aAAa,EAAE,qCAAqC,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC7F;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,oBAAoB;AACtB;AACA,eAAe,eAAe,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC3E,YAAY,eAAe,EAAE;AAC7B,sCAAsC,cAAc,EAAE;;AAEtD,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;AACA,gBAAgB,gBAAgB,EAAE,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACzF,cAAc,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AACjE,gBAAgB,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACvE,iBAAiB,cAAc,EAAE,kBAAkB,EAAE;AACrD,mBAAmB,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC/D;EACE,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,2BAA2B;AAC7B;AACA,oBAAoB,sBAAsB,EAAE;AAC5C;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA,uBAAuB,sBAAsB,EAAE,cAAc,EAAE;AAC/D;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA,cAAc;AACd,eAAe,uBAAuB,EAAE,+CAA+C,EAAE;AACzF,mBAAmB,aAAa,EAAE;AAClC,YAAY,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACnE,eAAe,aAAa,EAAE,SAAS,EAAE;AACzC;EACE,SAAO;EACP,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;AACA,2BAA2B,qBAAqB,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;AACA,2CAA2C,sBAAsB,EAAE;AACnE,+BAA+B,eAAe,EAAE,YAAY,EAAE;;AAE9D,aAAa;AACb,eAAe,gBAAgB,EAAE,SAAS,EAAE,SAAS,EAAE;AACvD;EACE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,6CAA6C;EAC7C,uCAAuC;AACzC;AACA,+BAA+B,mBAAmB,EAAE,kBAAkB,EAAE;AACxE,+BAA+B,mBAAmB,EAAE,UAAU,EAAE,WAAW,EAAE;AAC7E;EACE,KAAK,UAAU,EAAE,kCAAkC,EAAE;EACrD,OAAO,UAAU,EAAE,6DAA6D,EAAE;AACpF;;AAEA,eAAe;AACf;EACE,aAAa,0BAA0B,EAAE,SAAS,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;EACjG,eAAe,eAAe,EAAE;EAChC,cAAc,eAAe,EAAE;EAC/B,eAAe,aAAa,EAAE;EAC9B,aAAa,kBAAkB,EAAE;EACjC,WAAW,uCAAuC,EAAE;EACpD,WAAW,qCAAqC,EAAE;AACpD;;AAEA,kFAAkF;AAClF;EACE,WAAW,kBAAkB,EAAE;EAC/B,aAAa,kBAAkB,EAAE;EACjC,WAAW,YAAY,EAAE;EACzB,aAAa,SAAS,EAAE,oBAAoB,EAAE;EAC9C,eAAe,eAAe,EAAE,gBAAgB,EAAE;EAClD,cAAc,aAAa,EAAE;EAC7B;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;EACrB;EACA,aAAa,kBAAkB,EAAE;EACjC,kBAAkB,cAAc,EAAE;EAClC,aAAa,eAAe,EAAE;EAC9B,WAAW,qCAAqC,EAAE,QAAQ,EAAE;EAC5D,qBAAqB,iBAAiB,EAAE,eAAe,EAAE;EACzD,mBAAmB,eAAe,EAAE;EACpC,eAAe,uBAAuB,EAAE;EACxC,0EAA0E;EAC1E,qBAAqB,eAAe,EAAE,kBAAkB,EAAE;EAC1D,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACnD","sourcesContent":["/* Book a Demo — conversational booking page (brand: Midnight #071D31, Steel #3B6B94, Turquoise #6CE5E8) */\n\n.bd-page {\n  min-height: 100vh;\n  background: radial-gradient(1200px 700px at 80% -10%, #10375c 0%, #071d31 55%, #050f1c 100%);\n  font-family: 'Greycliff CF', 'Segoe UI', sans-serif;\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.bd-glow {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(90px);\n  opacity: 0.35;\n  pointer-events: none;\n  animation: bd-float 12s ease-in-out infinite alternate;\n}\n.bd-glow-a { width: 420px; height: 420px; background: #6ce5e8; top: -140px; left: -120px; }\n.bd-glow-b { width: 520px; height: 520px; background: #3b6b94; bottom: -200px; right: -160px; animation-delay: -6s; }\n@keyframes bd-float { from { transform: translateY(0) } to { transform: translateY(50px) } }\n\n.bd-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 22px 40px;\n  position: relative;\n  z-index: 2;\n}\n.bd-logo { height: 40px; }\n.bd-back { color: #9fc3d9; text-decoration: none; font-size: 14px; }\n.bd-back:hover { color: #6ce5e8; }\n\n.bd-layout {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 1fr 480px;\n  gap: 48px;\n  max-width: 1160px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 20px 40px 48px;\n  align-items: center;\n  position: relative;\n  z-index: 2;\n}\n\n.bd-pitch h1 { font-size: 46px; font-weight: 800; line-height: 1.15; margin-bottom: 18px; }\n.bd-pitch h1 span { color: #6ce5e8; }\n.bd-pitch p { color: #b8cddd; font-size: 17px; line-height: 1.65; max-width: 420px; }\n.bd-pitch ul { list-style: none; padding: 0; margin-top: 26px; }\n.bd-pitch li { color: #d7e6f0; margin-bottom: 12px; font-size: 15px; }\n\n/* ── Chat card ─────────────────────────────── */\n.bd-chat {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(108, 229, 232, 0.18);\n  backdrop-filter: blur(18px);\n  border-radius: 22px;\n  display: flex;\n  flex-direction: column;\n  height: min(680px, calc(100vh - 140px));\n  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.45);\n  overflow: hidden;\n}\n\n.bd-chat-top {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(7, 29, 49, 0.5);\n}\n.bd-agent-name { font-weight: 700; font-size: 15px; }\n.bd-agent-role { font-size: 12px; color: #8fb4cc; }\n\n.bd-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3b6b94, #6ce5e8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  color: #071d31;\n  position: relative;\n  flex-shrink: 0;\n}\n.bd-avatar-sm { width: 28px; height: 28px; font-size: 12px; align-self: flex-end; }\n.bd-online {\n  position: absolute;\n  bottom: 1px;\n  right: 1px;\n  width: 10px;\n  height: 10px;\n  background: #2fdd7f;\n  border-radius: 50%;\n  border: 2px solid #0b2740;\n}\n\n.bd-stream {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  scroll-behavior: smooth;\n  position: relative;\n}\n\n.bd-row { display: flex; gap: 8px; animation: bd-pop 0.28s ease both; }\n.bd-row-user { justify-content: flex-end; }\n@keyframes bd-pop {\n  from { opacity: 0; transform: translateY(10px) scale(0.97); }\n  to { opacity: 1; transform: none; }\n}\n\n.bd-bubble-wrap { max-width: 82%; }\n.bd-bubble {\n  padding: 11px 15px;\n  border-radius: 16px;\n  font-size: 14.5px;\n  line-height: 1.5;\n  width: fit-content;\n}\n.bd-bubble-agent {\n  background: rgba(255, 255, 255, 0.1);\n  border-bottom-left-radius: 4px;\n  color: #eaf4fa;\n}\n.bd-bubble-user {\n  background: linear-gradient(135deg, #6ce5e8, #3fd3d7);\n  color: #071d31;\n  font-weight: 600;\n  border-bottom-right-radius: 4px;\n  margin-left: auto;\n}\n.bd-celebrate { border: 1px solid rgba(108, 229, 232, 0.5); box-shadow: 0 0 24px rgba(108, 229, 232, 0.25); }\n\n/* typing dots */\n.bd-typing { display: flex; gap: 5px; padding: 14px 16px; }\n.bd-typing span {\n  width: 7px; height: 7px; border-radius: 50%;\n  background: #8fb4cc;\n  animation: bd-blink 1.1s infinite;\n}\n.bd-typing span:nth-child(2) { animation-delay: 0.18s; }\n.bd-typing span:nth-child(3) { animation-delay: 0.36s; }\n@keyframes bd-blink { 0%, 60%, 100% { opacity: 0.3; transform: translateY(0); } 30% { opacity: 1; transform: translateY(-3px); } }\n\n/* chips / days / slots */\n.bd-chips, .bd-slots { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }\n.bd-chip, .bd-slot {\n  background: transparent;\n  border: 1px solid rgba(108, 229, 232, 0.55);\n  color: #6ce5e8;\n  border-radius: 999px;\n  padding: 8px 16px;\n  font-size: 13.5px;\n  cursor: pointer;\n  transition: all 0.18s;\n  font-family: inherit;\n}\n.bd-chip:hover, .bd-slot:hover, .bd-day:hover {\n  background: #6ce5e8;\n  color: #071d31;\n  transform: translateY(-1px);\n}\n\n.bd-days { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-top: 10px; }\n.bd-day {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(108, 229, 232, 0.35);\n  color: #eaf4fa;\n  border-radius: 12px;\n  padding: 9px 6px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  transition: all 0.18s;\n  font-family: inherit;\n}\n.bd-day span { font-size: 11px; color: #8fb4cc; text-transform: uppercase; }\n.bd-day b { font-size: 13px; }\n.bd-day:hover span, .bd-day:hover b { color: #071d31; }\n\n/* confirm card */\n.bd-card {\n  margin-top: 10px;\n  background: rgba(7, 29, 49, 0.65);\n  border: 1px solid rgba(108, 229, 232, 0.35);\n  border-radius: 16px;\n  padding: 16px 18px;\n}\n.bd-card-when { font-weight: 800; font-size: 15.5px; color: #6ce5e8; margin-bottom: 8px; }\n.bd-card-tz { font-weight: 400; font-size: 12px; color: #8fb4cc; }\n.bd-card-line { font-size: 13.5px; color: #cfe2ee; margin-bottom: 3px; }\n.bd-card-focus { color: #8fb4cc; font-style: italic; }\n.bd-card-actions { display: flex; gap: 10px; margin-top: 14px; }\n.bd-confirm {\n  background: linear-gradient(135deg, #6ce5e8, #3fd3d7);\n  color: #071d31;\n  font-weight: 700;\n  border: none;\n  border-radius: 10px;\n  padding: 10px 20px;\n  cursor: pointer;\n  font-family: inherit;\n  transition: transform 0.15s;\n}\n.bd-confirm:hover { transform: scale(1.04); }\n.bd-teams-link {\n  display: inline-block;\n  margin-top: 10px;\n  background: linear-gradient(135deg, #6ce5e8, #3fd3d7);\n  color: #071d31;\n  font-weight: 700;\n  font-size: 13.5px;\n  text-decoration: none;\n  border-radius: 10px;\n  padding: 10px 18px;\n  transition: transform 0.15s;\n}\n.bd-teams-link:hover { transform: scale(1.04); color: #071d31; }\n.bd-edit {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: #cfe2ee;\n  border-radius: 10px;\n  padding: 10px 16px;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n/* input bar */\n.bd-inputbar { padding: 14px 16px 18px; border-top: 1px solid rgba(255, 255, 255, 0.08); }\n.bd-inputbar-off { opacity: 0.45; }\n.bd-error { color: #ffb1b1; font-size: 12.5px; margin-bottom: 6px; }\n.bd-inputrow { display: flex; gap: 10px; }\n.bd-inputrow input {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(108, 229, 232, 0.25);\n  border-radius: 999px;\n  padding: 12px 18px;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  font-family: inherit;\n}\n.bd-inputrow input:focus { border-color: #6ce5e8; }\n.bd-inputrow input::placeholder { color: #7d9cb3; }\n.bd-inputrow button {\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  border: none;\n  background: linear-gradient(135deg, #6ce5e8, #3b6b94);\n  color: #071d31;\n  font-size: 17px;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n.bd-inputrow button:not(:disabled):hover { transform: scale(1.08); }\n.bd-inputrow button:disabled { cursor: default; opacity: 0.6; }\n\n/* confetti */\n.bd-confetti { position: sticky; bottom: 0; height: 0; }\n.bd-confetti i {\n  position: absolute;\n  bottom: 0;\n  left: calc(4% * var(--i));\n  width: 8px;\n  height: 13px;\n  background: #6ce5e8;\n  opacity: 0;\n  animation: bd-confetti 1.6s ease-out forwards;\n  animation-delay: calc(0.05s * var(--i));\n}\n.bd-confetti i:nth-child(3n) { background: #3b6b94; border-radius: 50%; }\n.bd-confetti i:nth-child(4n) { background: #ffffff; width: 6px; height: 6px; }\n@keyframes bd-confetti {\n  0% { opacity: 1; transform: translateY(0) rotate(0); }\n  100% { opacity: 0; transform: translateY(-340px) rotate(540deg) translateX(30px); }\n}\n\n/* responsive */\n@media (max-width: 991px) {\n  .bd-layout { grid-template-columns: 1fr; gap: 24px; padding: 10px 20px 30px; align-items: start; }\n  .bd-pitch h1 { font-size: 32px; }\n  .bd-pitch p { font-size: 15px; }\n  .bd-pitch ul { display: none; }\n  .bd-header { padding: 18px 20px; }\n  .bd-chat { height: min(620px, calc(100vh - 220px)); }\n  .bd-days { grid-template-columns: repeat(4, 1fr); }\n}\n\n/* phones: the chat IS the page — compact pitch, chat fills the visible viewport */\n@media (max-width: 575px) {\n  .bd-page { min-height: 100dvh; }\n  .bd-header { padding: 12px 16px; }\n  .bd-logo { height: 30px; }\n  .bd-layout { gap: 12px; padding: 0 12px 16px; }\n  .bd-pitch h1 { font-size: 22px; margin-bottom: 0; }\n  .bd-pitch p { display: none; }\n  .bd-chat {\n    height: calc(100vh - 150px);\n    height: calc(100dvh - 150px);\n    border-radius: 18px;\n  }\n  .bd-stream { padding: 14px 12px; }\n  .bd-bubble-wrap { max-width: 90%; }\n  .bd-bubble { font-size: 14px; }\n  .bd-days { grid-template-columns: repeat(4, 1fr); gap: 6px; }\n  .bd-chip, .bd-slot { padding: 8px 13px; font-size: 13px; }\n  .bd-card-actions { flex-wrap: wrap; }\n  .bd-inputbar { padding: 10px 10px 12px; }\n  /* 16px stops iOS Safari from zooming the page when the input gets focus */\n  .bd-inputrow input { font-size: 16px; padding: 11px 16px; }\n  .bd-inputrow button { width: 44px; height: 44px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
